module.exports = __webpack_public_path__ + "static/media/s.2cd5cc30.svg";